import { isNil } from 'lodash';
import {
	APIFactoryOptions,
	DependentDetails,
	GetJourneyDetails,
	PrincipalDetails,
	getJourney,
} from '@shory-health-individual/customer-api';
import AppInit from './app-init';
import { refreshAppInitServerData } from './get-app-init-server-data';

type AddedDetails = {
	gender?: string;
	nationality?: string;
	relationship?: string;
	salaryBand?: string;
	maritalStatus?: string;
	emirate?: string;
	occupation?: string;
};

export type Principal = PrincipalDetails & AddedDetails;

export type Dependent = DependentDetails & AddedDetails;

export type Member = Dependent | Principal;

export type JourneyDetails = GetJourneyDetails & { principalDetails: Principal; dependents?: Dependent[] };

const addDetails = (member: Member, appInit: AppInit) => {
	const memberDetails = {
		...member,
		gender: appInit.getGenderById(member.genderId)?.name,
		nationality: appInit.getCountryById(member.nationalityId)?.name,
		relationship: appInit.getRelationshipById(member.relationshipTypeId)?.name,
		maritalStatus: appInit.getMaritalStatusById(member.maritalStatusId)?.name,
	};

	if (!isNil(member.salaryBandId)) {
		memberDetails.salaryBand = appInit.getSalaryBandById(member.salaryBandId)?.name;
	}

	if (!isNil(member.emirateId)) {
		memberDetails.emirate = appInit.getEmirateById(member.emirateId)?.name;
	}

	if (!isNil(member.occupationId)) {
		memberDetails.occupation = appInit.getOccupationById(member.occupationId)?.name;
	}

	return memberDetails;
};

const getJourneyDetails = async (
	serverDataConnection: APIFactoryOptions,
	journeyId: string
): Promise<JourneyDetails> => {
	const [journey] = await Promise.all([
		getJourney(serverDataConnection)({ parameters: { journeyId } }),
		refreshAppInitServerData(serverDataConnection),
	]);

	const appInit = new AppInit(serverDataConnection.locale ?? 'en');

	return {
		...journey,
		principalDetails: addDetails(journey.principalDetails, appInit),
		dependents: journey.dependents?.map((dependent) => addDetails(dependent, appInit)),
	};
};

export default getJourneyDetails;
